"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isInRange = void 0;

/**
 * @Function
 *
 * @name skybase-components.sb-ipv4-input.utils#isInRange
 * @param {skybase-components.sb-ipv4-input.utils#Range} range
 * @param {Number} position
 * @return {Boolean}
 */
var isInRange = function isInRange(range, position) {
  return range[0] <= position && position <= range[1];
};

exports.isInRange = isInRange;
//# sourceMappingURL=is-in-range.js.map